//  axiosによる通信エラー
export class HttpError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'HttpError';

    Object.setPrototypeOf(this, HttpError.prototype); //< `instanceof` が正しく機能するようにするための設定
  }
}

//  表示を目的としたエラー
export class DisplayError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'DisplayError';

    Object.setPrototypeOf(this, DisplayError.prototype); //< `instanceof` が正しく機能するようにするための設定
  }
}
